// src/api/axiosInstance.js
import axios from 'axios';
import Cookies from 'universal-cookie';

const cookie = new Cookies();

const axiosInstance = axios.create({
  baseURL:
    process.env.NEXT_PUBLIC_ANALYTICSV2_API_URL ||
    'https://backend-v2.stag.tradewing.com',
  timeout: 30000, // Adjust timeout as needed
});

// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    config.headers['x-api-key'] =
      'aHR0cHM6Ly93d3cueW91dHViZS5jb20vd2F0Y2g/dj1kUXc0dzlXZ1hjUQ';
    if (!config.headers['x-user-id']) {
      config.headers['x-user-id'] = 'hardik';
    }

    // Get tokens from cookies
    const accessToken = cookie.get('accounts%3AaccessToken');
    const refreshToken = cookie.get('accounts%3ArefreshToken');

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    if (refreshToken) {
      config.headers['x-refresh-token'] = refreshToken;
    }
    // Optionally, set x-tenant-id if needed
    
    // config.headers['x-tenant-id'] = 'bkjPDRjKTb65zkfbB';


    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle global errors (e.g., token expiry, network errors)
    if (error.response?.status === 401) {
      // Handle unauthorized error (e.g., logout user)
      // Optional: Redirect to login or refresh token
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
